<div class="modal-header">
    <h4 class="modal-title">{{name}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <div class="row info">
        @if (imagePath) {
            <div class="col-4">
                <img [src]="imagePath" class="announcement-image" />
            </div>
        }
        <div class="col">
            <p id="announcement-message">{{body}}</p>
        </div>
    </div>
    @if (hasStateChange) {
        <div class="row results-container">
            <div class="col-auto">
                <div class="results card">
                    <app-critter-state-update [stateUpdate]="stateUpdate"></app-critter-state-update>
                </div>
            </div>
        </div>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()">Close</button>
</div>
